import React, { useEffect, useState } from 'react';
import { api } from '@/lib/db';
import { Card } from '@/components/ui/Components';
import SafeIcon from '@/common/SafeIcon';

const FAQ = () => {
  const [faqs, setFaqs] = useState([]);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    api.getFaq().then(setFaqs).catch(() => {});
  }, []);

  return (
    <div className="space-y-8 max-w-3xl">
      {/* ─── Bevezető ─────────────────────────────────────────────────── */}
      <div>
        <h1 className="text-3xl font-black text-gray-900 dark:text-white">GYIK / Súgó</h1>
        <p className="text-gray-500 dark:text-gray-400 mt-1">Gyakran feltett kérdések a SocialCard Review használatáról.</p>
      </div>

      {/* ─── Hogyan működik kártya ────────────────────────────────────── */}
      <Card className="p-8 bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-blue-900/30 dark:to-indigo-900/30 border-blue-100 dark:border-blue-800">
        <h2 className="text-xl font-bold text-blue-900 dark:text-blue-300 mb-4 flex items-center gap-2">
          <SafeIcon name="Zap" className="w-5 h-5 text-blue-600 dark:text-blue-400" />
          Hogyan működik a SocialCard Review?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="bg-white dark:bg-gray-700 rounded-xl p-4 border border-blue-100 dark:border-blue-800">
            <div className="w-8 h-8 bg-blue-600 text-white rounded-lg flex items-center justify-center font-black text-sm mb-3">1</div>
            <h3 className="font-bold text-gray-900 dark:text-white mb-1">Ügyfél értékel</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400">A vendég megnyitja az értékelő oldalt QR kódon vagy NFC-n keresztül, és választ 1–5 csillagot.</p>
          </div>
          <div className="bg-white dark:bg-gray-700 rounded-xl p-4 border border-blue-100 dark:border-blue-800">
            <div className="w-8 h-8 bg-green-600 text-white rounded-lg flex items-center justify-center font-black text-sm mb-3">2</div>
            <h3 className="font-bold text-gray-900 dark:text-white mb-1">Értékelés</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400"><strong>4–5 csillag:</strong> Átirányítás a Google értékelési oldalra. <strong>1–3 csillag:</strong> Visszajelzést ír a véleményével kapcsolatban.</p>
          </div>
          <div className="bg-white dark:bg-gray-700 rounded-xl p-4 border border-blue-100 dark:border-blue-800">
            <div className="w-8 h-8 bg-purple-600 text-white rounded-lg flex items-center justify-center font-black text-sm mb-3">3</div>
            <h3 className="font-bold text-gray-900 dark:text-white mb-1">Eredmény</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400">Több pozitív Google értékelés, a negatív visszajelzések privátban kerülnek hozzád.</p>
          </div>
        </div>
      </Card>

      {/* ─── Gyors útmutató ───────────────────────────────────────────── */}
      <Card className="p-6">
        <h2 className="text-lg font-bold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
          <SafeIcon name="BookOpen" className="w-5 h-5 text-gray-600 dark:text-gray-400" /> Gyors útmutató
        </h2>
        <ol className="space-y-3 text-sm text-gray-700 dark:text-gray-300">
          <li className="flex items-start gap-3">
            <span className="w-6 h-6 bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-300 rounded-full flex items-center justify-center font-bold text-xs flex-shrink-0 mt-0.5">1</span>
            <span><strong>Hozz létre egy cégprofilt</strong> az „Értékelhető cégprofilok" menüpontban. Add meg a Google értékelési linkedet, logódat és a kívánt szövegeket.</span>
          </li>
          <li className="flex items-start gap-3">
            <span className="w-6 h-6 bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-300 rounded-full flex items-center justify-center font-bold text-xs flex-shrink-0 mt-0.5">2</span>
            <span><strong>Másold ki az egyedi linket</strong> a cégprofilról és használd ezt a Google értékelések gyűjtésére.</span>
          </li>
          <li className="flex items-start gap-3">
            <span className="w-6 h-6 bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-300 rounded-full flex items-center justify-center font-bold text-xs flex-shrink-0 mt-0.5">3</span>
            <span><strong>Állítsd be az értesítési e-mailt</strong> a „Beállítások" menüpontban, hogy azonnal értesülj minden beérkező visszajelzésről.</span>
          </li>
          <li className="flex items-start gap-3">
            <span className="w-6 h-6 bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-300 rounded-full flex items-center justify-center font-bold text-xs flex-shrink-0 mt-0.5">4</span>
            <span><strong>Kövesd az eredményeket</strong> a Vezérlőpulton: lásd hány Google átirányítás és beérkezett visszajelzés érkezett.</span>
          </li>
        </ol>
      </Card>

      {/* ─── FAQ kérdések ─────────────────────────────────────────────── */}
      {faqs.length > 0 && (
        <div>
          <h2 className="text-lg font-bold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
            <SafeIcon name="HelpCircle" className="w-5 h-5 text-gray-600 dark:text-gray-400" /> Gyakran feltett kérdések
          </h2>
          <div className="space-y-2">
            {faqs.map((faq) => (
              <div
                key={faq.id}
                className={`bg-white dark:bg-gray-800 rounded-xl border shadow-sm overflow-hidden transition-all ${
                  open === faq.id
                    ? 'border-blue-200 dark:border-blue-700 ring-2 ring-blue-100 dark:ring-blue-900'
                    : 'border-gray-100 dark:border-gray-700'
                }`}
              >
                <button
                  type="button"
                  className="w-full p-5 flex items-center justify-between gap-4 text-left hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
                  onClick={() => setOpen(open === faq.id ? null : faq.id)}
                >
                  <p className="font-semibold text-gray-900 dark:text-white text-sm">{faq.question}</p>
                  <SafeIcon
                    name={open === faq.id ? 'ChevronUp' : 'ChevronDown'}
                    className="w-4 h-4 text-gray-400 dark:text-gray-500 flex-shrink-0"
                  />
                </button>
                {open === faq.id && (
                  <div className="px-5 pb-5 border-t border-gray-100 dark:border-gray-700 pt-4">
                    <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* ─── Kapcsolat ────────────────────────────────────────────────── */}
      <Card className="p-6 bg-gray-50 dark:bg-gray-700/50 border-gray-200 dark:border-gray-600">
        <div className="flex items-start gap-4">
          <div className="p-3 bg-white dark:bg-gray-700 rounded-xl border border-gray-200 dark:border-gray-600">
            <SafeIcon name="Mail" className="w-5 h-5 text-blue-600 dark:text-blue-400" />
          </div>
          <div>
            <h3 className="font-bold text-gray-900 dark:text-white">Elakadtál vagy nem találtad meg a választ?</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
              Vedd fel velünk a kapcsolatot és segítünk!{' '}
              <a href="mailto:info@socialcard.hu" className="text-blue-600 dark:text-blue-400 hover:underline font-medium">
                info@socialcard.hu
              </a>
            </p>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default FAQ;
